import {
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpResponse,
} from '@angular/common/http';
import { catchError, tap, throwError } from 'rxjs';
import {
  readLoanApplicationApiSuccessMessage,
  showLoanApplicationApiError,
  showLoanApplicationSuccessToast,
} from '../pages/loan-application/utils/loan-application-api-feedback.util';
import {
  isLoanApplicationMutationRequest,
  LOAN_APPLICATION_API_ERROR_TITLE,
  SUPPRESS_LOAN_APPLICATION_API_ERROR,
  SUPPRESS_LOAN_APPLICATION_API_SUCCESS,
} from '../pages/loan-application/utils/loan-application-api-http.context';

/** LA-US-044 / LA-US-045: toast on mutation success/error; skip list/read GET APIs. */
export const loanApplicationApiFeedbackInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isLoanApplicationMutationRequest(req.method, req.url)) {
    return next(req);
  }

  const suppressError = req.context.get(SUPPRESS_LOAN_APPLICATION_API_ERROR);
  const suppressSuccess = req.context.get(SUPPRESS_LOAN_APPLICATION_API_SUCCESS);

  return next(req).pipe(
    tap((event) => {
      if (suppressSuccess || !(event instanceof HttpResponse)) {
        return;
      }
      const message = readLoanApplicationApiSuccessMessage(event.body);
      if (message) {
        void showLoanApplicationSuccessToast(message);
      }
    }),
    catchError((error: unknown) => {
      if (suppressError) {
        return throwError(() => error);
      }
      if (error instanceof HttpErrorResponse && error.status === 401) {
        return throwError(() => error);
      }
      if (error instanceof HttpErrorResponse) {
        const title =
          req.context.get(LOAN_APPLICATION_API_ERROR_TITLE).trim() ||
          'Unable to complete request';
        void showLoanApplicationApiError(error, title);
      }
      return throwError(() => error);
    }),
  );
};
